<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="区域" prop="orgName">
              <el-input
                v-model="searchForm.orgName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="经销商" prop="customerName">
              <el-input
                v-model="searchForm.customerName"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>

            <el-form-item label="经销商经营状态" prop="businessStatus">
              <el-select v-model="searchForm.businessStatus" clearable @change="onSearch">
                <el-option v-for="item in businessStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商户号" prop="mchNo">
              <el-input
                v-model="searchForm.mchNo"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="法人" prop="legalName">
              <el-input
                v-model="searchForm.legalName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="审核状态" prop="status">
              <el-select v-model="searchForm.status" clearable @change="onSearch">
                <el-option v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
         
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="exportFile">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="orgName" label="区域" align="center" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="customerName" label="经销商" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="businessStatus" label="经销商经营状态" align="center" width="120"></el-table-column>
          <el-table-column prop="mchNo" label="商户号" align="center" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="legalName" label="法人姓名" align="center" width="120"></el-table-column>
          <el-table-column prop="applyDate" label="申请时间" align="center" width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applyUserName" label="申请人" align="center" width="120"></el-table-column>
          <el-table-column prop="applyUserStatus" label="申请人状态" align="center" width="120"></el-table-column>
          <el-table-column prop="frozenMarginAmount" label="冻结保证金" align="center" width="120"></el-table-column>
          <el-table-column prop="status" label="审核状态" align="center" width="120"></el-table-column>
          <el-table-column prop="handleUserName" label="审核人" align="center" width="120"></el-table-column>
          <el-table-column prop="handleTime" label="审核时间" align="center" width="160"></el-table-column>
          <el-table-column prop="handleRemark" label="拒绝理由" align="center" width="120"></el-table-column>
          <el-table-column  label="操作" align="center" width="150">
            <template slot-scope="scope" v-if="scope.row.status == '待审核'">

              <el-button type="text" size="small" @click="audit(1,scope.row)">
                同意
              </el-button>
              <el-button type="text" size="small" @click="audit(2,scope.row)">
                拒绝
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
      <audit-dialog ref="auditRef" @auditSuccess="init"/>
    </content-panel>
    
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
import auditDialog from './componets/audit-dialog'
import moment from 'moment';
export default {
  name: "withdrawalList",
  mixins: [tableMixin,pagePathMixin],
  components: { auditDialog },
  data() {
    return {
      searchForm: {
        orgName: "",
        customerName: "",
        mchNo: "",
        legalName: "",
        status: "",
      },
      businessStatus: [ 
        {value: '', label: '全部'},
        {value: 1, label: '正常营业'},
        {value: 2, label: '预停业'},
        {value: 3, label: '已停业'},
        {value: 4, label: '预营业'},
        {value: 5, label: '未开业停用'},
        {value: 6, label: '经营异常'},
      ],
      statusOptions: [
        {value: '', label: '全部'},
        {value: '0', label: '待审核'},
        {value: '1', label: '已同意 '},
        {value: '2', label: '已拒绝 '},
      ],
      // 表格相关
      tableData: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
    };
  },
  methods: {
    init() {
      this.onSearch();
      this.getOrgBoardInfo();
    },
    getOrgBoardInfo() {
      this.$api.dataReport.orgBoardInfo().then((res) => {
        this.panelData = res.data;
      });
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.dataReport
        .unionMchFrozenMarginAuditPageList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    audit(type,row) {
      this.$refs.auditRef.open(type,row)
    },
    exportFile() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("unionMchFrozenMarginAuditPageList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    },
  },
  mounted() {
    this.init();
  },
  filters: {
    businessStatus(value) {
      let map = {
        1:'正常营业',
        2:'预停业',
        3:'已停业',
        4:'预营业',
        5:'未开业停用',
        6:'经营异常'
      }
      return map[value]
    }
  },
};
</script>
<style lang="stylus" scoped>
.date-input {
  width 220px !important
}

</style>
